import React from "react";
import { Link, useNavigate } from "react-router-dom";
import loginimg from "../Assets/Img/loginsideimg.png";
import googlesignup from "../Assets/Img/google-signup.png";
import axiosMain from "../http/axiosMain";
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId =
  "316679652217-44dun9ch1kjuhpmqpdda6ha5t1s3shsn.apps.googleusercontent.com";
function LoginWithPhoneOrEmail() {
  const navigate = useNavigate(); // Hook to navigate between routes
  const handleGoogleSuccess = async () => {
    try {
      // const token = credentialResponse.credential; // Get Google JWT token

      const response = await axiosMain.get("api/auth/google", {
        params: {
          redirect: window.origin,
          role: "brand",
        },
      });

      if (response.data.status) {
        console.log("Authentication Successful:", response.data);
        localStorage.setItem("authToken", true);
        const role = response.data?.user?.role;
        // Store user data
        localStorage.setItem("user", JSON.stringify(response.data.user));
        console.log("google login", response.data);
        // window.location.href = response.data.data;
        // response.data;
        role === "brand"
          ? navigate("/brand-home", { replace: true })
          : role === "influencer"
          ? navigate("/influencer-home", { replace: true })
          : role === "admin"
          ? navigate("/admin/influencers", { replace: true })
          : navigate("/", { replace: true });

        // Redirect to Brand Home Page
        // navigate("/brand-home");
      } else {
        console.error("Authentication Failed:", response.data.message);
      }
    } catch (error) {
      console.error(
        "Google Login Error:",
        error.response?.data || error.message
      );
    }
  };
  return (
    <>
      <GoogleOAuthProvider clientId={clientId}>
        <div className="container-phone-email p-0 mt-5 mb-5">
          <div className="card">
            <div className="row no-gutters">
              {/* Left Side (Image Section) */}
              <div className="col-12 col-md-6 left">
                <img src={loginimg} alt="phone-email" className="img" />
              </div>

              {/* Right Side (Login and Signup Buttons) */}
              <div className="col-12 col-md-6 right">
                <div className="row">
                  <div className="col-12 col-md-12 text-center">
                    <h2>
                      Collaborate.
                      <br /> Create. Connect.
                    </h2>

                    <button
                      type="button"
                      className="btn btn-outline-success btn-lg mb-3"
                      onClick={handleGoogleSuccess}
                    >
                      <img
                        src={googlesignup}
                        alt="Phone Icon"
                        className="icon mr-2"
                        style={{
                          width: "17px",
                          height: "25px",
                          marginRight: "16px",
                        }}
                      />
                      Continue with Google
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-success btn-lg mb-2"
                      onClick={() => navigate("/phone")} // Navigate to PhoneEmail page
                    >
                      Log In with Phone No.
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-success btn-lg mb-3"
                      onClick={() => navigate("/email")} // Navigate to PhoneEmail page
                    >
                      Log In with Email
                    </button>
                  </div>

                  <div className="col-12 col-md-12 footer">
                    <div className="sign-link mt-auto">
                      Not having a Account? &nbsp;
                      {/* Add link to navigate back to the signup page */}
                      <Link
                        to="/signup"
                        className="btn-link"
                        //   onClick={() => navigate("/phone-email")} // Navigate to PhoneEmail page
                      >
                        Sign up &nbsp;
                      </Link>
                      here
                    </div>
                    <div className="signup-instruction">
                      By continuing you agree to our terms and conditions
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </GoogleOAuthProvider>
    </>
  );
}

export default LoginWithPhoneOrEmail;
